import { statusCodes } from '@layers/web/constants/statuses.js'
import type { ApiOptionalOptions } from '@layers/web/types/api-fetch.ts'

export const apiFetch = async <ApiResponse = any>(
  request: string,
  options: ApiOptionalOptions = {}
): Promise<{ data: ApiResponse; error: any } & Record<string, any>> => {
  const requestOptions = createRequestOptions(options)
  const { throwOnFail, simple } = requestOptions

  if (!isValidFileType(request, requestOptions)) {
    return {
      data: {} as ApiResponse,
      error: { message: 'Invalid file type', statusCode: statusCodes.UNSUPPORTED_MEDIA_TYPE },
    }
  }

  const headers = createRequestHeaders(requestOptions)

  logHttpRequest(request, requestOptions)

  const apiUrl = createApiUrl(request, requestOptions)

  try {
    const response = await $fetch.raw(apiUrl, {
      headers,
      ...requestOptions,
    })

    parseHttpResponseToCookie(simple, response)

    return {
      ...response,
      data: response._data as ApiResponse,
      error: null,
    }
  } catch (error) {
    return logFailedHttpRequest(error, throwOnFail)
  }
}